import TenantEmailSyncConfigModal from 'features/Ascent/EmailSyncConfigSetting/TenantEmailSyncConfigModal';
import { useState } from 'react';
import { Box, Button } from '@mui/material';
import SettingsIcon from '@mui/icons-material/Settings';
import { useOutletContext } from 'react-router';

const ConfigureEmailSyncRules = () => {
	const [emailRulesModalOpen, setEmailRulesModalOpen] = useState(false);
	const { tenant, user, showNotification } = useOutletContext();

	const ConfigureEmailSyncRulesButton = () => {
		return (
			<Button
				variant='contained'
				sx={{ width: '300px' }}
				onClick={() => setEmailRulesModalOpen(true)}
				startIcon={<SettingsIcon />}
			>
				Configure Email Sync Rules
			</Button>
		);
	};

	return (
		<Box sx={{ marginBottom: '16px' }}>
			<ConfigureEmailSyncRulesButton />

			<TenantEmailSyncConfigModal
				tenant={tenant}
				user={user}
				open={emailRulesModalOpen}
				onClose={() => setEmailRulesModalOpen(false)}
				showNotification={showNotification}
			/>
		</Box>
	);
};

export default ConfigureEmailSyncRules;
